<template>
	
	<div  :class = "((page=='index')?'header_box':'header_box_inner_page')+' row page_padding'">
		<div :class = "(page=='index')?'all_kind':'all_kind_inner_page'">
			全部分类
		</div>
		<span @click  ="toIndex" class="finger fo">首页</span>
		<span class = "finger fo" @click = "searchTopOrderType(item)" v-for = "(item,index) in systemData.topOrderType" :key = "index">
			 {{item.label}}
		</span>
		<span @click = "openGYWM">关于我们</span>
		<GYWM ref = "gywm"></GYWM>
	</div>
	
</template>

<script>
	import {mapGetters} from 'vuex'
	import {searchOrderType,searchTopOrderType} from '../../utils/index.js'
	import {toIndex} from '../../utils/index.js'
	import GYWM from '../article/GYWM.vue'
	export default{
		components:{
			GYWM
		},
		computed:{
			...mapGetters(['systemData'])
		},
		props:{
			
			page:String
			
		},
		data(){
			
			return{
				
				
			}
			
		},
		methods:{
			toIndex,
			searchOrderType,
			searchTopOrderType,
			openGYWM(){
				console.log('[this]',this);
				this.$refs['gywm'].artcleShow=true
				
			}
		}
		
		
		
	}
	
	
</script>

<style>
	.row{
		
		display: flex;
		align-items: center;
		
	}
	.row span{
		
		margin-left: 4vw;
		font-weight: 800;
		font-size: 1vw;
	}
	.all_kind{
		width: 13.85vw;
			height: 3.44vw;
			background-image: linear-gradient(-70deg, 
				#2982fe 0%, 
				#29a7f9 100%, 
				#8e9ac5 100%, 
				#f38d90 100%), 
			linear-gradient(
				#0d0216, 
				#0d0216);
			background-blend-mode: normal, 
				normal;
			border-radius: 0.83vw 0.83vw 0vw 0vw;
			line-height: 3.44vw;
			color: #FFFFFF;
	}
	
	.all_kind_inner_page{
		width: 13.854vw;
			height: 3.438vw;
			background-color: #3049a0;
			border-radius: 0.833vw 0.833vw 0vw 0vw;
			color: #FFFFFF;
			line-height: 3.438vw;
	}
	.fo:hover{
		
		color: #0056ad;
		
	}
	.header_box_inner_page{
		padding-top: 3vw;
		height: 3.44vw;
		border-bottom: #3049a0 0.208vw solid;
		background-color: #FFFFFF;
	}
	.header_box{
		padding-top: 3vw;
		height: 3.44vw;
		 background-color: #FFFFFF;
	}
</style>
